<div class="app-notification-item">
    <ion-item lines="full" [ngClass]="{'unread': notification.status != 'READ','read': notification.status == 'READ'}">
        <ion-label no-margin text-wrap>
            <p class="notification-content">{{notificationContent}}</p>
            <ion-chip [ngClass]="'type'" [color]="'transparent'">

                <div class="time-container">
                    <p [matTooltip]="notification.sendDate | date" [matTooltipPosition]="'after'"> <i
                            class="fa fa-comments"></i> {{notification.sendDate | timeAgo}}</p>
                    <div class="options">
                        <ion-button size="small" fill="none" (click)="showOptions($event)">
                            <ion-icon size="small" color="medium" slot="icon-only" name="ellipsis-vertical"></ion-icon>
                        </ion-button>

                        <ion-button (click)="toggleRead($event)"
                            [matTooltip]="(notification.status === 'READ' ? 'notifications.markAsUnread' : 'notifications.markAsRead') | translate"
                            [matTooltipPosition]="'before'" aria-label="" size="small" fill="none">
                            <ion-icon *ngIf="notification.status !== 'READ'" class="unread-icon pi pi-check"
                                name="checkmark-outline"></ion-icon>
                            <ion-icon *ngIf="notification.status === 'READ'" class="read-icon pi pi-check-circle"
                                name="checkmark-circle-outline"></ion-icon>
                        </ion-button>
                    </div>
                </div>

                <ion-icon size="small" color="medium" [name]="'chatboxes'"></ion-icon>
            </ion-chip>
        </ion-label>
    </ion-item>
</div>